import {
  overlaySlideInTop,
  overlaySlideInRight,
  overlaySlideInBottom,
  overlaySlideInLeft,
  overlaySlideOutTop,
  overlaySlideOutRight,
  overlaySlideOutBottom,
  overlaySlideOutLeft,
} from '../_core/animations/slide';
import { css, styled } from '../theme';

export const ContentBase = styled.div`
  ${({ theme }) => css`
    box-sizing: border-box;
    z-index: 9999;
    padding: ${theme.spacings.xs};
    display: flex;
    flex-direction: column;
    gap: ${theme.spacings.xxs};
    min-width: 200px;
    background: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray[200]};
    border-radius: ${theme.radiuses.s};
    will-change: transform, opacity;
    animation-duration: ${theme.tokens.animation.duration.base};
    animation-timing-function: ${theme.tokens.animation.easing.standard};
    overflow-y: auto;
    overflow-x: hidden;

    &[data-state='open'] {
      &[data-side='top'] {
        animation-name: ${overlaySlideInTop};
      }
      &[data-side='right'] {
        animation-name: ${overlaySlideInRight};
      }
      &[data-side='bottom'] {
        animation-name: ${overlaySlideInBottom};
      }
      &[data-side='left'] {
        animation-name: ${overlaySlideInLeft};
      }
    }

    &[data-state='closed'] {
      &[data-side='top'] {
        animation-name: ${overlaySlideOutTop};
      }
      &[data-side='right'] {
        animation-name: ${overlaySlideOutRight};
      }
      &[data-side='bottom'] {
        animation-name: ${overlaySlideOutBottom};
      }
      &[data-side='left'] {
        animation-name: ${overlaySlideOutLeft};
      }
    }
  `}
`;

export const PortalContent = styled(ContentBase)`
  position: fixed;
`;

export const InlineContent = styled(ContentBase)`
  position: absolute;
`;

export const InlineWrapper = styled.div`
  position: relative;
  display: inline-flex;
`;

export const ItemEl = styled.div<{
  $critical?: boolean;
}>`
  ${({ theme, $critical }) => css`
    box-sizing: border-box;
    flex: 1;
    display: flex;
    align-items: center;
    min-height: 32px;
    cursor: pointer;
    outline: none;
    user-select: none;

    padding-inline: ${theme.spacings.s};
    gap: ${theme.radiuses.xs};
    border-radius: ${theme.radiuses.xxs};
    color: ${$critical ? theme.colors.red[500] : theme.colors.gray[800]};
    transition-property: background-color, color;
    transition-duration: ${theme.tokens.animation.duration.base};

    &:hover,
    &:focus,
    &[data-state='open'] {
      background-color: ${$critical
        ? theme.colors.red[500]
        : theme.colors.gray[100]};
      color: ${$critical ? theme.colors.white : 'currentColor'};
    }

    &[data-disabled] {
      color: ${theme.colors.gray[400]};
      cursor: not-allowed;
    }
  `}
`;

export const SeparatorEl = styled.div`
  ${({ theme }) => css`
    height: 1px;
    background: ${theme.colors.gray[200]};
    margin: ${theme.spacings.xxs} 0;
  `}
`;

export const SubTriggerEl = styled(ItemEl)`
  justify-content: space-between;
`;

export const LabelEl = styled.div`
  ${({ theme }) => css`
    padding: ${theme.spacings.xs} ${theme.spacings.m};
    color: ${theme.colors.gray[600]};
    user-select: none;
  `}
`;
